import React, { Component } from "react";
import { Table, List, Checkbox, Button } from "semantic-ui-react";
import _ from "lodash";
import DppaSelection from "./DppaSelection";
import { ERR_SELECT_ITEM_IN_LIST } from "../../ErrorMessages";
import { getReportComparison } from "../dialogs/ReportComparison";

function trimStart(character, string) {
  let startIndex = 0;

  while (string[startIndex] === character) {
    startIndex += 1;
  }

  return string.substr(startIndex);
}

class ReportSelection extends Component {
  constructor(props) {
    super(props);
    const compReport = _.find(
      this.props.uiData.Reports,
      (a) => a.ReportID === 23
    );
    let compCost = "0.00";
    if (compReport) compCost = trimStart("$", compReport.SearchResultCost);
    if (
      compCost.toLowerCase() === "free" ||
      compCost.toLowerCase() === "included"
    )
      compCost = 0;
    compCost = parseFloat(compCost);

    const compPlusReport = _.find(
      this.props.uiData.Reports,
      (a) => a.ReportID === 58
    );
    let compPlusCost =
      compPlusReport === undefined
        ? undefined
        : trimStart("$", compPlusReport.SearchResultCost);
    compPlusCost = parseFloat(compPlusCost);

    this.state = {
      compCost,
      compPlusCost,
      compReport,
      compPlusReport,
      selectedReports: [],
      compPlusSelectedReports: [],
      compDppa: { dppa: "-1", userPickedState: "-1" },
      compPlusDppa: { dppa: "-1", userPickedState: "-1" },
      compDppaErrors: {},
      compPlusDppaErrors: {},
      dialogActive: false,
      hideCompReport: _.get(props.reportData, "personReport.person[0].uniqueId") !== undefined,
    };
  }

  onCompAddonChange = (e, data) => {
    const { selectedReports } = this.state;
    let cost = data.custom.SearchResultCost;
    if (!cost || isNaN(cost))
      cost = !cost || cost.toLowerCase() === "included" ? 0 : cost;
    if (data.checked === true) {
      selectedReports.push(data.custom.ReportOpt);
      this.setState({
        compCost: this.state.compCost + cost,
        selectedReports,
      });
    } else {
      const index = selectedReports.indexOf(data.custom.ReportOpt);
      selectedReports.splice(index, 1);
      if (data.custom.ReportOpt === "mvraddon") {
        this.setState({
          compCost: this.state.compCost - cost,
          selectedReports,
          compDppa: { dppa: "-1", userPickedState: "-1" },
        });
      } else {
        this.setState({
          compCost: this.state.compCost - cost,
          selectedReports,
        });
      }
    }
  };

  onCompPlusAddonChange = (e, data) => {
    const { compPlusSelectedReports } = this.state;
    let cost = data.custom.SearchResultCost;
    if (!cost || isNaN(cost))
      cost = !cost || cost.toLowerCase() === "included" ? 0 : cost;
    if (data.checked === true) {
      compPlusSelectedReports.push(data.custom.ReportOpt);
      this.setState({
        compPlusCost: this.state.compPlusCost + cost,
        compPlusSelectedReports,
      });
    } else {
      const index = compPlusSelectedReports.indexOf(data.custom.ReportOpt);
      compPlusSelectedReports.splice(index, 1);
      if (data.custom.ReportOpt === "mvraddonplat") {
        this.setState({
          compPlusCost: this.state.compPlusCost - cost,
          compPlusSelectedReports,
          compPlusDppa: { dppa: "-1", userPickedState: "-1" },
        });
      } else {
        this.setState({
          compPlusCost: this.state.compPlusCost - cost,
          compPlusSelectedReports,
        });
      }
    }
  };

  onDppaUseChange = (controlId, value) => {
    if (controlId === "comp") {
      const compDppa = this.state.compDppa;
      compDppa.dppa = value;
      const compDppaErrors = this.state.compDppaErrors;
      if (value === "-1") compDppaErrors.dppa = ERR_SELECT_ITEM_IN_LIST;
      else delete compDppaErrors.dppa;
      this.setState({ compDppa, compDppaErrors });
    } else {
      const compPlusDppa = this.state.compPlusDppa;
      compPlusDppa.dppa = value;
      const compPlusDppaErrors = this.state.compPlusDppaErrors;
      if (value === "-1") compPlusDppaErrors.dppa = ERR_SELECT_ITEM_IN_LIST;
      else delete compPlusDppaErrors.dppa;
      this.setState({ compPlusDppa, compPlusDppaErrors });
    }
  };

  onDppaStateChange = (controlId, value) => {
    if (controlId === "comp") {
      const compDppa = this.state.compDppa;
      compDppa.userPickedState = value;
      const compDppaErrors = this.state.compDppaErrors;
      if (value === "-1")
        compDppaErrors.userPickedState = ERR_SELECT_ITEM_IN_LIST;
      else delete compDppaErrors.userPickedState;
      this.setState({ compDppa, compDppaErrors });
    } else {
      const compPlusDppa = this.state.compPlusDppa;
      compPlusDppa.userPickedState = value;
      const compPlusDppaErrors = this.state.compPlusDppaErrors;
      if (value === "-1")
        compPlusDppaErrors.userPickedState = ERR_SELECT_ITEM_IN_LIST;
      else delete compPlusDppaErrors.userPickedState;
      this.setState({ compPlusDppa, compPlusDppaErrors });
    }
  };

  openDialog = () => {
    this.setState({ dialogActive: true });
    // getReportComparison({
    //   active: this.state.dialogActive,
    //   closeDialog: this.closeDialog,
    // });
  };

  closeDialog = () => {
    this.setState({ dialogActive: false });
  };

  handleReportSubmit = (e, data) => {
    e.preventDefault();
    if (this.props.internalNameID === "-1") {
      this.props.showNameSelectionError();
      return;
    }
    this.setState({ compDppaErrors: {}, compPlusDppaErrors: {} });
    if (data === "comp" && this.state.selectedReports.includes("mvraddon")) {
      const compDppaErrors = {};
      let valid = true;
      if (this.state.compDppa.dppa === "-1") {
        valid = false;
        compDppaErrors.dppa = ERR_SELECT_ITEM_IN_LIST;
      }
      if (this.state.compDppa.userPickedState === "-1") {
        valid = false;
        compDppaErrors.userPickedState = ERR_SELECT_ITEM_IN_LIST;
      }
      if (!valid) {
        this.setState({ compDppaErrors });
        return;
      }
    } else if (
      data === "compplus" &&
      this.state.compPlusSelectedReports.includes("mvraddonplat")
    ) {
      const compPlusDppaErrors = {};
      let valid = true;
      if (this.state.compPlusDppa.dppa === "-1") {
        valid = false;
        compPlusDppaErrors.dppa = ERR_SELECT_ITEM_IN_LIST;
      }
      if (this.state.compPlusDppa.userPickedState === "-1") {
        valid = false;
        compPlusDppaErrors.userPickedState = ERR_SELECT_ITEM_IN_LIST;
      }
      if (!valid) {
        this.setState({ compPlusDppaErrors });
        return;
      }
    }
    let userPickedState = "";
    if (data === "comp") {
      if (this.state.compDppa.userPickedState !== undefined)
        userPickedState = this.state.compDppa.userPickedState;
    } else if (this.state.compPlusDppa.userPickedState !== undefined) {
      userPickedState = this.state.compPlusDppa.userPickedState;
    }
    const additionalData = {
      reportID:
        data === "comp"
          ? this.state.compReport.ReportID
          : this.state.compPlusReport.ReportID,
      internalNameID: this.props.internalNameID,
      bttype: this.props.userAccount.btType,
      optReportType: data,
      selectedReports:
        data === "comp"
          ? this.state.selectedReports
          : this.state.compPlusSelectedReports,
      dppa:
        data === "comp"
          ? this.state.compDppa.dppa
          : this.state.compPlusDppa.dppa,
      userPickedState,
      savedResultID: this.props.additionalData
        ? this.props.additionalData.savedResultID
        : undefined,
    };
    if (data === "compplus") {
      additionalData.requestedSection = "compReportResponse";
    }
    this.props.showReport(
      "",
      "personReport",
      this.props.internalId,
      additionalData
    );
  };

  render() {
    const compPlusReport = _.find(
      this.props.uiData.Reports,
      (a) => a.ReportID === 58
    );
    const compReport = _.find(
      this.props.uiData.Reports,
      (a) => a.ReportID === 23
    );
    const { internalId, userAccount } = this.props;
    // const compMvrReport = _.find(
    //   this.props.uiData.Reports,
    //   a => a.ReportID === 24
    // );

    const compAddonReports = [];
    if (compReport.AddOnIds !== "") {
      compAddonReports.push(
        <List.Item key={"comp_add_options"}>
          Add Options: (Click as many as you want)
        </List.Item>
      );
      const tokens = compReport.AddOnIds.split(",");
      _.forEach(tokens, (token) => {
        const addOnRep = _.find(
          this.props.uiData.Reports,
          (a) => a.ReportID === parseInt(token, 10)
        );
        let repCost = trimStart("$", addOnRep.SearchResultCost);
        if (repCost.toLowerCase() === "free") repCost = 0;
        repCost = parseFloat(repCost);
        if (addOnRep.ReportOpt.includes("mvr")) {
          if (
            this.props.userAccount.btType !== "3" &&
            this.props.userAccount.restrictLN === "0"
          )
            compAddonReports.push(
              <List.Item key={`comp_nr_addon_${addOnRep.ReportOpt}`}>
                <Checkbox
                  key={`${internalId}_${addOnRep.ReportOpt}`}
                  id={`${internalId}_${addOnRep.ReportOpt}`}
                  defaultChecked={
                    addOnRep.SearchResultCost.toLowerCase() === "free" ||
                    addOnRep.SearchResultCost === "$0.00" ||
                    this.state.selectedReports.includes(addOnRep.ReportOpt)
                  }
                  custom={{
                    ReportOpt: addOnRep.ReportOpt,
                    SearchResultCost: repCost,
                  }}
                  onClick={(e, data) => this.onCompAddonChange(e, data)}
                  label={`${addOnRep.ReportLabel} - ${addOnRep.SearchResultCost}`}
                />
              </List.Item>
            );
          if (this.state.selectedReports.indexOf(addOnRep.ReportOpt) !== -1)
            compAddonReports.push(
              <List.Item key={`comp_addon_${addOnRep.ReportOpt}`}>
                <DppaSelection
                  reportName={addOnRep.ReportOpt}
                  {...this.props}
                  controlId={"comp"}
                  onDppaUseChange={this.onDppaUseChange}
                  onDppaStateChange={this.onDppaStateChange}
                  errors={this.state.compDppaErrors}
                  selData={this.state.compDppa}
                />
              </List.Item>
            );
        } else {
          compAddonReports.push(
            <List.Item key={`comp_addon_${addOnRep.ReportOpt}`}>
              <Checkbox
                key={`${internalId}_${addOnRep.ReportOpt}`}
                id={`${internalId}_${addOnRep.ReportOpt}`}
                defaultChecked={
                  addOnRep.SearchResultCost.toLowerCase() === "free" ||
                  addOnRep.SearchResultCost === "$0.00" ||
                  this.state.selectedReports.includes(addOnRep.ReportOpt)
                }
                custom={{
                  ReportOpt: addOnRep.ReportOpt,
                  SearchResultCost: repCost,
                }}
                onClick={(e, data) => this.onCompAddonChange(e, data)}
                label={`${addOnRep.ReportLabel} - ${addOnRep.SearchResultCost}`}
              />
            </List.Item>
          );
        }
      });
    }
    const compPlusAddonReports = [];
    if (compPlusReport !== undefined && compPlusReport.AddOnIds !== "") {
      compPlusAddonReports.push(
        <List.Item key={`compplus_add_options`}>Add Options:</List.Item>
      );
      const tokens = compPlusReport.AddOnIds.split(",");
      _.forEach(tokens, (token) => {
        const addOnRep = _.find(
          this.props.uiData.Reports,
          (a) => a.ReportID === parseInt(token, 10)
        );
        let repCost = trimStart("$", addOnRep.SearchResultCost);
        if (repCost.toLowerCase() === "free") repCost = 0;
        repCost = parseFloat(repCost);
        if (addOnRep.ReportOpt.includes("mvr")) {
          compPlusAddonReports.push(
            <List.Item key={`compplus_addon_${addOnRep.ReportOpt}`}>
              <Checkbox
                key={`${internalId}_${addOnRep.ReportOpt}`}
                id={`${internalId}_${addOnRep.ReportOpt}`}
                defaultChecked={
                  addOnRep.SearchResultCost.toLowerCase() === "free" ||
                  addOnRep.SearchResultCost === "$0.00" ||
                  this.state.selectedReports.includes(addOnRep.ReportOpt)
                }
                custom={{
                  ReportOpt: addOnRep.ReportOpt,
                  SearchResultCost: repCost,
                }}
                onClick={(e, data) => this.onCompPlusAddonChange(e, data)}
                label={`${addOnRep.ReportLabel} - ${addOnRep.SearchResultCost}`}
              />
            </List.Item>
          );
          if (
            this.props.userAccount.btType !== "3" &&
            this.state.compPlusSelectedReports.indexOf(addOnRep.ReportOpt) !==
            -1
          )
            compPlusAddonReports.push(
              <List.Item key={`compplus_nr_addon_${addOnRep.ReportOpt}`}>
                <DppaSelection
                  reportName={addOnRep.ReportOpt}
                  {...this.props}
                  controlId={"compplus"}
                  onDppaUseChange={this.onDppaUseChange}
                  onDppaStateChange={this.onDppaStateChange}
                  errors={this.state.compPlusDppaErrors}
                  selData={this.state.compPlusDppa}
                />
              </List.Item>
            );
        } else {
          compPlusAddonReports.push(
            <List.Item key={`compplus_addon_${addOnRep.ReportOpt}`}>
              <Checkbox
                key={addOnRep.ReportOpt}
                id={addOnRep.ReportOpt}
                defaultChecked={
                  addOnRep.SearchResultCost.toLowerCase() === "free" ||
                  addOnRep.SearchResultCost === "$0.00" ||
                  this.state.selectedReports.includes(addOnRep.ReportOpt)
                }
                custom={{
                  ReportOpt: addOnRep.ReportOpt,
                  SearchResultCost: repCost,
                }}
                onClick={(e, data) => this.onCompPlusAddonChange(e, data)}
                label={`${addOnRep.ReportLabel} - ${addOnRep.SearchResultCost}`}
              />
            </List.Item>
          );
        }
      });
    }
    const repWidth = compPlusReport && compPlusReport !== null ? "100%" : "50%";
    const { hideCompReport } = this.state;
    return (
      <Table
        className="report-dialog report-summary-definition"
        style={{ width: repWidth }}
      >
        <Table.Body>
          <Table.Row className="text-bold">
            {!hideCompReport && (<Table.Cell
              width={8}
              className={
                userAccount.acctTheme === 0
                  ? "border-right text-center large-font gold-report-summary-definition"
                  : "border-right text-center large-font"
              }
            >
              <span
                className={
                  userAccount.acctTheme !== 0
                    ? "report-sub-sub-section-header"
                    : ""
                }
              >
                GOLD Report - {compReport.SearchResultCost}
              </span>
            </Table.Cell>)}
            {compPlusReport && compPlusReport !== null && (
              <Table.Cell
                width={8}
                className={
                  userAccount.acctTheme === 0
                    ? "border-right text-center large-font platinum-report-summary-definition"
                    : "border-right text-center large-font"
                }
              >
                <span
                  className={
                    userAccount.acctTheme !== 0
                      ? "report-sub-section-header"
                      : ""
                  }
                >
                  PLATINUM Report - {compPlusReport.SearchResultCost}
                </span>
                <br />
                <span className={"text-center red-text medium-font"}>
                  Most up-to-date and accurate!
                </span>
              </Table.Cell>
            )}
          </Table.Row>
          <Table.Row className="text-bold">
            {!hideCompReport && (<Table.Cell
              width={8}
              className={
                userAccount.acctTheme === 0
                  ? "border-right large-font gold-report-summary-definition"
                  : "border-right large-font"
              }
            >
              Includes:
              <List className="ui bulleted list">
                <List.Item>Name</List.Item>
                <List.Item>Alias Names</List.Item>
                <List.Item>
                  Date Of Birth{" "}
                  <span className="red-text">* For Qualifying Businesses</span>
                </List.Item>
                <List.Item>Address History with Map</List.Item>
                <List.Item>Phone records with Carrier</List.Item>
                <List.Item>Properties</List.Item>
                <List.Item>Relatives</List.Item>
                <List.Item>Neighbors</List.Item>
                <List.Item>Common Residency</List.Item>
                <List.Item>Email and Social Media</List.Item>
              </List>
            </Table.Cell>)}
            {compPlusReport && compPlusReport !== null && (
              <Table.Cell
                width={8}
                className={
                  userAccount.acctTheme === 0
                    ? "large-font platinum-report-summary-definition"
                    : "large-font"
                }
              >
                Includes:
                <Table
                  className={
                    "table-no-border-and-padding margin-top-0 background-color-transparent"
                  }
                >
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <List className="ui bulleted list">
                          <List.Item>Name</List.Item>
                          <List.Item>Alias Names</List.Item>
                          <List.Item>
                            Date Of Birth{" "}
                            <span className="red-text">
                              * For Qualifying Businesses
                            </span>
                          </List.Item>
                          <List.Item>Address History with Map</List.Item>
                          <List.Item>Phone records with Carrier</List.Item>
                          <List.Item>Properties</List.Item>
                          <List.Item>Comprehensive Relatives</List.Item>
                          <List.Item>Comprehensive Neighbors</List.Item>
                          <List.Item>Common Residency</List.Item>
                          <List.Item>Email and Social Media</List.Item>
                        </List>
                      </Table.Cell>
                      <Table.Cell>
                        <List className="ui bulleted list">
                          <List.Item>Imposters</List.Item>
                          <List.Item>Bankruptcies</List.Item>
                          <List.Item>Liens</List.Item>
                          <List.Item>UCC</List.Item>
                          <List.Item>Judgments</List.Item>
                          <List.Item>People At Work</List.Item>
                          <List.Item>Professional Licenses</List.Item>
                          <List.Item>Associates</List.Item>
                          <List.Item>Corporate Affiliations</List.Item>
                          <List.Item>Criminal Records</List.Item>
                          <List.Item>Sexual Offenses</List.Item>
                        </List>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Cell>
            )}
          </Table.Row>
          <Table.Row className="text-bold">
            {!hideCompReport && (<Table.Cell
              width={8}
              className={
                userAccount.acctTheme === 0
                  ? "border-right gold-report-summary-definition"
                  : "border-right"
              }
            >
              <List>{compAddonReports}</List>
            </Table.Cell>)}
            {compPlusReport && compPlusReport !== null && (
              <Table.Cell
                width={8}
                className={
                  userAccount.acctTheme === 0
                    ? "platinum-report-summary-definition"
                    : ""
                }
              >
                <List>{compPlusAddonReports}</List>
              </Table.Cell>
            )}
          </Table.Row>
          <Table.Row className="text-bold">
            {!hideCompReport && (<Table.Cell
              width={8}
              className={
                userAccount.acctTheme === 0
                  ? "border-right gold-report-summary-definition"
                  : "border-right"
              }
            >
              <span />
            </Table.Cell>)}
            {compPlusReport && compPlusReport !== null && (
              <Table.Cell
                width={8}
                className={
                  userAccount.acctTheme === 0
                    ? "platinum-report-summary-definition text-center"
                    : ""
                }
              >
                {getReportComparison({
                  active: this.state.dialogActive,
                  closeDialog: this.closeDialog,
                  openDialog: this.openDialog,
                })}
              </Table.Cell>
            )}
          </Table.Row>
          <Table.Row className="text-bold">
            {!hideCompReport && (<Table.Cell
              width={8}
              className={
                userAccount.acctTheme === 0
                  ? "border-right gold-report-summary-definition"
                  : "border-right"
              }
            >
              <Table
                className={
                  "table-no-border-and-padding margin-top-0 background-color-transparent"
                }
              >
                <Table.Body>
                  <Table.Row key={`Row_Rep_Comp_Bot`}>
                    <Table.Cell className={"icon-align-middle repRightCol"}>
                      <span
                        className={
                          userAccount.acctTheme === 0
                            ? "text-bold report-price"
                            : ""
                        }
                      >
                        Report Price:{" "}
                        <span
                          className={
                            userAccount.acctTheme === 0 ? "red-text" : ""
                          }
                        >{`$${this.state.compCost.toFixed(2)}`}</span>
                      </span>
                    </Table.Cell>
                    <Table.Cell>
                      {compReport.BlockSearch === 0 ? (
                        <Button
                          primary
                          className={
                            userAccount.acctTheme === 0 ? "classic-button" : ""
                          }
                          onClick={(e) => this.handleReportSubmit(e, "comp")}
                        >
                          Get Report
                        </Button>
                      ) : (
                        <span className={"red-text"}>
                          You are not authorized to run this report
                        </span>
                      )}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Table.Cell>)}
            {compPlusReport && compPlusReport !== null && (
              <Table.Cell
                width={8}
                className={
                  userAccount.acctTheme === 0
                    ? "platinum-report-summary-definition"
                    : ""
                }
              >
                <Table
                  className={
                    "table-no-border-and-padding margin-top-0 background-color-transparent"
                  }
                >
                  <Table.Body>
                    <Table.Row key={`Row_Rep_Comp_Bot`}>
                      <Table.Cell
                        className={"icon-align-middle padding-top-10"}
                      >
                        <span
                          className={
                            userAccount.acctTheme === 0
                              ? "text-bold report-price"
                              : ""
                          }
                        >
                          Report Price:{" "}
                          <span
                            className={
                              userAccount.acctTheme === 0 ? "red-text" : ""
                            }
                          >{`$${this.state.compPlusCost.toFixed(2)}`}</span>
                        </span>
                      </Table.Cell>
                      <Table.Cell className={"padding-top-10"}>
                        {compPlusReport.BlockSearch === 0 ? (
                          <Button
                            primary
                            className={
                              userAccount.acctTheme === 0
                                ? "classic-button"
                                : ""
                            }
                            onClick={(e) =>
                              this.handleReportSubmit(e, "compplus")
                            }
                          >
                            Get Report
                          </Button>
                        ) : (
                          <span className={"red-text"}>
                            You are not authorized to run this report
                          </span>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </Table.Cell>
            )}
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default ReportSelection;



// WEBPACK FOOTER //
// ./src/components/searchresults/ReportSelection.js